import { Episode, GuildRolesQuery, Maybe, Project, Scalars } from '@/types/codegen-federation'

const GUILD_PROMOTION_REGIONS = new Set(['US', 'CA'])

type User = GuildRolesQuery['user']

type EarlyAccessEpisodeProps = {
  earlyAccessDate?: Maybe<Scalars['ISO_DateTime']['output']>
  publiclyAvailableDate?: Maybe<Scalars['ISO_DateTime']['output']>
  unavailableReason?: Maybe<string>
}

export interface GuildPlanSelectionNew {
  currency?: string
  price: number
  monthlyPrice: number
  tier: 'basic' | 'premium'
}

export const shouldPromoteGuild = ({ region }: { region: string }) => {
  return GUILD_PROMOTION_REGIONS.has(region)
}

export function isEarlyAccessEpisodeAndAccessible(isGuildTierExperimentOn: boolean, user: User, episode: Episode) {
  const doesUserHaveEarlyAccess = isGuildTierExperimentOn
    ? hasEarlyAccessRole(user)
    : Boolean(episode?.userHasEarlyAccess)

  return isEarlyAccessEpisode(episode) && doesUserHaveEarlyAccess
}

const UPSELL_REASONS = new Set(['PRERELEASE', 'PRESALE']) as Set<string>
export function isEarlyAccessEpisode(episode: EarlyAccessEpisodeProps | undefined): boolean {
  if (!episode?.unavailableReason) return false
  const hasEarlyAccessDate = !!episode?.earlyAccessDate
  const hasUpsellReason = UPSELL_REASONS.has(episode?.unavailableReason)
  const isSameDate = episode?.earlyAccessDate === episode?.publiclyAvailableDate

  return hasEarlyAccessDate && hasUpsellReason && !isSameDate
}

export function getProjectInEarlyAccess(data: Project) {
  const firstSeason = data?.seasons?.[0]
  const firstEpisode = firstSeason?.episodes?.[0]
  const lastSeason = data?.seasons?.[data?.seasons?.length - 1]
  const lastEpisode = lastSeason?.episodes?.[lastSeason?.episodes?.length - 1]
  return Boolean(
    (firstSeason && firstEpisode && isEarlyAccessEpisode(firstEpisode)) ||
      (lastSeason && lastEpisode && isEarlyAccessEpisode(lastEpisode)),
  )
}

/**
 * Uses new guildRoles from guild_membership_tiers_experiment
 */
export function hasEarlyAccessRole(user?: User): boolean {
  return Boolean(user?.guildRoles?.hasEarlyAccess)
}
